import { defineStore } from 'pinia'
import api from '@/api/axios'

const getOrderId = (order) => order?.id || order?._id?.$oid || order?._id || null

export const useOrdersStore = defineStore('orders', {
    state: () => ({
        orders: {
            items: [],
            count: 0
        },
        currentOrder: null,
        pageSize: 20,
    }),
    getters: {
        allOrders: (state) =>
            state.orders.items.map((order) => ({
                ...order,
                id: getOrderId(order),
                customer: order?.customer?.name || order?.customer?.email || order?.customer || '',
            })),
        countPages: (state) => Math.ceil(state.orders.count / state.pageSize) || 1,
    },

    actions: {
        async getOrders(page = 1) {
            try {
                const response = await api.get(`/orders?limit=${this.pageSize}&page=${page}`)
                this.orders = response.data
            } catch (error) {
                console.error('Failed to fetch orders:', error)
                throw error
            }
        },

        async getOrder(id) {
            try {
                const response = await api.get(`/orders/${id}`)
                this.currentOrder = response.data
            } catch (error) {
                console.error('Failed to fetch order:', error)
                throw error
            }
        },

        async addOrder(orderData) {
            try {
                const response = await api.post('/orders', orderData)
                if (!Array.isArray(this.orders.items)) {
                    this.orders.items = []
                }
                this.orders.items.push(response.data)
                this.orders.count += 1
                this.currentOrder = response.data
                return response.data
            } catch (error) {
                console.error('Failed to add order:', error)
                throw error
            }
        },

        async updateOrder(id, orderData) {
            try {
                const response = await api.put(`/orders/${id}`, orderData)
                const index = this.orders.items.findIndex((order) => String(getOrderId(order)) === String(id))
                if (index !== -1) {
                    this.orders.items[index] = response.data
                }
                this.currentOrder = response.data
                return response.data
            } catch (error) {
                console.error('Failed to update order:', error)
                throw error
            }
        },
    },
})
